import { render } from "./PtTeacherKakaoManagement.vue?vue&type=template&id=1523ed62"
import script from "./PtTeacherKakaoManagement.vue?vue&type=script&lang=js"
export * from "./PtTeacherKakaoManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__